import React from 'react';
import { Modal, FormGroup, ControlLabel, FormControl, Button, Form, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const BuildBundlesModal = ({show, hide, scene, data, updated, submitted}) => {
    return (
        <Modal show={show} onHide={hide}>
            <Modal.Header closeButton>
                <Modal.Title>Build Bundles for {scene}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form horizontal onSubmit={submitted}>
                    {formTextField('Branch Name', 'The name of the branch to build these bundles for.', updated, data.branchNameValid)}
                    <hr/>

                    {renderButton(data.isRequestingBuild, data.formValid)}
                </Form>
            </Modal.Body>
        </Modal>
    );
};

const renderButton = (isRequesting, isFormValid) =>
{
    if(isRequesting)
    {
        return( 
            <Button type="submit" style={{backgroundColor:'blue', color: 'white'}} block disabled={isRequesting}>Requesting Build...</Button>
        );
    }
    else
    {
        return(
            <Button type="submit" bsStyle="success" block disabled={!isFormValid && !isRequesting}>Build</Button>            
        )
    }
}

const formTextField = (label, placeholder, onChange, validation) => {
    return (
        <FormGroup controlId={`formHorizontal${label}`} validationState={validation}>
            <Col componentClass={ControlLabel} sm={3}>{label}</Col>
            <Col sm={9}>
                <FormControl type='text' name={label} placeholder={placeholder} onChange={onChange} />
                <FormControl.Feedback />
            </Col>
        </FormGroup>
    );
};

const formOptionsField = (label,  options, onChange, validation) => {
    return (
        <FormGroup controlId={`formHorizontal${label}`} validationState={validation}>
            <Col componentClass={ControlLabel} sm={3}>{label}</Col>
            <Col sm={9}>
                <FormControl componentClass='select' name={label} onChange={onChange} defaultValue=''>
                    <option value='' disabled/>
                    {Object.entries(options).map(formOption)}
                </FormControl>
                <FormControl.Feedback />
            </Col>
        </FormGroup>
    );
};

const formOption = kvp => {
    return (<option key={kvp[0]} value={kvp[0]}>{kvp[1]}</option>);
};

BuildBundlesModal.propTypes = {
    show:       PropTypes.bool.isRequired,
    hide:       PropTypes.func.isRequired,
    scene:      PropTypes.string.isRequired,
    data:       PropTypes.object.isRequired,
    updated:    PropTypes.func.isRequired,
    submitted:  PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/buildBundlesModal/BuildBundlesModal.js